export default __webpack_public_path__ + "static/1-5-1-0-3f7e82a948445cb66c18d86e94a5e6d6.jpg";